const routes = [
  {
    label: "Dashboards",
    path: "/",
    icon: "dashboard",
  },
  {
    label: "Donor Application",
    path: "/donor-application",
    icon: "assignment",
  },
  {
    label: "Donor Info",
    path: "/donor-review",
    icon: "donor",
  },
  {
    label: "Press Coverage Category",
    path: "/press-coverage-category",
    icon: "press",
  },
  {
    label: "Digital Media",
    path: "/digital-media",
    icon: "media",
  },
  {
    label: "Video Gallery",
    path: "/video-gallery",
    icon: "video",
  },
  {
    label: "Electronic Media",
    path: "/electronic-media",
    icon: "tv",
  },
  {
    label: "Event Category",
    path: "/event-category",
    icon: "event",
  },
  {
    label: "Blogs",
    path: "/blogs",
    icon: "blogs",
  },
  {
    label: "Team Members",
    path: "/team-member",
    icon: "team",
  },
  {
    label: "Organ Category",
    path: "/organ-category",
    icon: "organCategory",
  },
   {
    label: "Donate Payment",
    path: "/payment",
    icon: "payment",
  },
];

export default routes;
